import React, {useEffect} from 'react';
import {Navigate, Route, Routes, useLocation, useParams} from 'react-router';

import {Page404} from "../../404";
import {ManyDevs} from "./list";
import {OneDev} from "./config";
import {OneDevControl} from "./control";

const DevsListRedirect = () => {
    const location = useLocation();
    return <Navigate to={`/devs/list${location.search}`} replace />;
};

const DevConfigRedirect = () => {
    const {resid} = useParams();
    const location = useLocation();
    return <Navigate to={`/devs/${resid}/control${location.search}`} replace />;
};

const ManyDevsRoute = () => {
    const location = useLocation();
    return <ManyDevs search={new URLSearchParams(location.search)} />;
};

const OneDevRoute = () => {
    const {resid} = useParams();
    return <OneDev devid={resid} />;
};

const DevControlRoute = () => {
    const {resid} = useParams();
    return <OneDevControl devid={resid} />;
};

const DevsPage = () => {
    useEffect(() => {
        console.log("Devs page");
    }, []);

    return <Routes>
        <Route path="/" element={<DevsListRedirect />} />
        <Route path="/list" element={<ManyDevsRoute />} />
        <Route path="/:resid" element={<DevConfigRedirect />} />
        <Route path="/:resid/config" element={<OneDevRoute />} />
        <Route path="/:resid/control" element={<DevControlRoute />} />
        <Route path="*" element={<Page404 />} />
    </Routes>
}

export { DevsPage };
